"use client";
import { Stack } from "@chakra-ui/react";
import CardsList from "@/components/cardsList";
import { scrollToElement } from "@/utils/scrollToElement";
import { Button } from "@/elements";
import { LBGhoverEffect } from "styles/hoverPresets";
import { HOSTED_NETBOX_FEATURES } from "./constants";

const Features = () => {
  return (
    <Stack gap={12}>
      <CardsList
        columns={{ base: 1, sm: 2, md: 4 }}
        title={HOSTED_NETBOX_FEATURES.title}
        list={HOSTED_NETBOX_FEATURES.list}
        spacing={{ base: 8, md: 12 }}
        hoverEffect
        hover={LBGhoverEffect}
      />
      <Button
        variant={"ideal"}
        onClick={() => scrollToElement("contact-us", 120)}
        alignSelf={"center"}
        p={6}
      >
        Try OneMind&apos;s Hosted Netbox
      </Button>
    </Stack>
  );
};

export default Features;
